import { TranscriptCategories } from '../model/transcript-categories.model';

export function filterSummaryByKeyword(
    keyWord: string | null,
    categories: TranscriptCategories[],
): TranscriptCategories[] {
    if (keyWord == null || keyWord.trim().length === 0) {
        return [...categories];
    }

    return categories.map((c) => {
        const nextC = { ...c };

        nextC.subCategories = c.subCategories.map((sub) => {
            const nextSub = { ...sub };

            nextSub.transcripts = sub.transcripts.filter((t) => {
                if (
                    t.title?.toLowerCase().includes(keyWord) ||
                    t.description?.toLowerCase().includes(keyWord) ||
                    t.primaryFocus?.behaviourName
                        ?.toLowerCase()
                        .includes(keyWord) === true ||
                    t.primaryFocus?.subBehaviourName
                        ?.toLowerCase()
                        .includes(keyWord) === true
                ) {
                    return true;
                }

                if (
                    t.behaviours.some((b) => {
                        return (
                            b.behaviourName?.toLowerCase().includes(keyWord) ||
                            b.subBehaviourName?.toLowerCase().includes(keyWord)
                        );
                    })
                ) {
                    return true;
                }

                return t.participants.some(
                    (p) => p?.toLowerCase().includes(keyWord),
                );
            });

            return nextSub;
        });

        return nextC;
    });
}
